import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";

export function PageLayout({
  seoTitle,
  seoJsonLd,
  seoDescription,
  path,
  eyebrow,
  title,
  subtitle,
  back = { to: "/", label: "Back to home" },
  testid = "page",
  children,
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [path]);

  return (
    <div className="bg-black min-h-screen grain" data-testid={testid}>
      <Seo title={seoTitle} description={seoDescription} path={path} jsonLd={seoJsonLd} />
      <Navbar />
      <main id="main-content" tabIndex={-1} className="max-w-[1100px] mx-auto px-6 lg:px-10 pt-36 pb-24">
        {back && (
          <Link
            to={back.to}
            className="text-xs uppercase tracking-widest text-fog hover:text-paper transition-colors"
            data-testid="page-back"
          >
            &larr; {back.label}
          </Link>
        )}
        <header className="mt-8">
          {eyebrow && <p className="text-xs uppercase tracking-[0.3em] text-fog mb-4">{eyebrow}</p>}
          <h1 className="font-display text-4xl sm:text-6xl tracking-tighter text-paper max-w-[20ch] leading-[0.95]">
            {title}
          </h1>
          {subtitle && <p className="mt-6 text-base text-fog leading-relaxed max-w-2xl">{subtitle}</p>}
        </header>
        <div className="mt-14">{children}</div>
      </main>
      <Footer />
    </div>
  );
}
